/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantStageStatusDto } from '../models';
// @ts-ignore
import type { TestAnswerDistributionDto } from '../models';
/**
 * TestStatisticsApi - axios parameter creator
 * @export
 */
export const TestStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Same data as `getTestAnswerDistribution`, exported as a multi-sheet `.xlsx` file (Filtry / Per pytanie / Per obszar / Per stanowisko / Per region). 
         * @summary Export answer distribution stats as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] 
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestAnswerDistribution: async (certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('exportTestAnswerDistribution', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('exportTestAnswerDistribution', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/answer-distribution/export`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionCodes) {
                localVarQueryParameter['positionCodes'] = positionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (testStatus) {
                localVarQueryParameter['testStatus'] = testStatus.join(COLLECTION_FORMATS.csv);
            }

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }

            if (testPassed !== undefined) {
                localVarQueryParameter['testPassed'] = testPassed;
            }

            if (testScoreMin !== undefined) {
                localVarQueryParameter['testScoreMin'] = testScoreMin;
            }

            if (testScoreMax !== undefined) {
                localVarQueryParameter['testScoreMax'] = testScoreMax;
            }

            if (testAttemptsMin !== undefined) {
                localVarQueryParameter['testAttemptsMin'] = testAttemptsMin;
            }

            if (testAttemptsMax !== undefined) {
                localVarQueryParameter['testAttemptsMax'] = testAttemptsMax;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated knowledge-test statistics for ALL participants matching the given participants-view filters (ignores pagination). For every participant the BEST attempt (highest `score`) is used.  Simplified variant (no cross-matrix): four independent breakdowns are returned in the same payload — per question, per section (area), per position and per region. 
         * @summary Get answer distribution stats for stage 2 (TEST)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Same semantics as on &#x60;/participants&#x60; (firstName, lastName, email, externalEmployeeId). 
         * @param {Array<string>} [positionCodes] Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Multi-value (CSV) - OR.
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR.
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestAnswerDistribution: async (certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestAnswerDistribution', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestAnswerDistribution', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/answer-distribution`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (positionCodes) {
                localVarQueryParameter['positionCodes'] = positionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (testStatus) {
                localVarQueryParameter['testStatus'] = testStatus.join(COLLECTION_FORMATS.csv);
            }

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }

            if (testPassed !== undefined) {
                localVarQueryParameter['testPassed'] = testPassed;
            }

            if (testScoreMin !== undefined) {
                localVarQueryParameter['testScoreMin'] = testScoreMin;
            }

            if (testScoreMax !== undefined) {
                localVarQueryParameter['testScoreMax'] = testScoreMax;
            }

            if (testAttemptsMin !== undefined) {
                localVarQueryParameter['testAttemptsMin'] = testAttemptsMin;
            }

            if (testAttemptsMax !== undefined) {
                localVarQueryParameter['testAttemptsMax'] = testAttemptsMax;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestStatisticsApi - functional programming interface
 * @export
 */
export const TestStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Same data as `getTestAnswerDistribution`, exported as a multi-sheet `.xlsx` file (Filtry / Per pytanie / Per obszar / Per stanowisko / Per region). 
         * @summary Export answer distribution stats as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] 
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestStatisticsApi.exportTestAnswerDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregated knowledge-test statistics for ALL participants matching the given participants-view filters (ignores pagination). For every participant the BEST attempt (highest `score`) is used.  Simplified variant (no cross-matrix): four independent breakdowns are returned in the same payload — per question, per section (area), per position and per region. 
         * @summary Get answer distribution stats for stage 2 (TEST)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Same semantics as on &#x60;/participants&#x60; (firstName, lastName, email, externalEmployeeId). 
         * @param {Array<string>} [positionCodes] Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Multi-value (CSV) - OR.
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR.
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestAnswerDistributionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestStatisticsApi.getTestAnswerDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestStatisticsApi - factory interface
 * @export
 */
export const TestStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestStatisticsApiFp(configuration)
    return {
        /**
         * Same data as `getTestAnswerDistribution`, exported as a multi-sheet `.xlsx` file (Filtry / Per pytanie / Per obszar / Per stanowisko / Per region). 
         * @summary Export answer distribution stats as XLSX
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {Array<string>} [positionCodes] 
         * @param {Array<string>} [regionCodes] 
         * @param {Array<ParticipantStageStatusDto>} [testStatus] 
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated knowledge-test statistics for ALL participants matching the given participants-view filters (ignores pagination). For every participant the BEST attempt (highest `score`) is used.  Simplified variant (no cross-matrix): four independent breakdowns are returned in the same payload — per question, per section (area), per position and per region. 
         * @summary Get answer distribution stats for stage 2 (TEST)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Same semantics as on &#x60;/participants&#x60; (firstName, lastName, email, externalEmployeeId). 
         * @param {Array<string>} [positionCodes] Multi-value (CSV) - OR.
         * @param {Array<string>} [regionCodes] Multi-value (CSV) - OR.
         * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR.
         * @param {number} [termId] 
         * @param {boolean} [testPassed] 
         * @param {number} [testScoreMin] 
         * @param {number} [testScoreMax] 
         * @param {number} [testAttemptsMin] 
         * @param {number} [testAttemptsMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): AxiosPromise<TestAnswerDistributionDto> {
            return localVarFp.getTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestStatisticsApi - interface
 * @export
 * @interface TestStatisticsApi
 */
export interface TestStatisticsApiInterface {
    /**
     * Same data as `getTestAnswerDistribution`, exported as a multi-sheet `.xlsx` file (Filtry / Per pytanie / Per obszar / Per stanowisko / Per region). 
     * @summary Export answer distribution stats as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [testStatus] 
     * @param {number} [termId] 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] 
     * @param {number} [testScoreMax] 
     * @param {number} [testAttemptsMin] 
     * @param {number} [testAttemptsMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStatisticsApiInterface
     */
    exportTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Returns aggregated knowledge-test statistics for ALL participants matching the given participants-view filters (ignores pagination). For every participant the BEST attempt (highest `score`) is used.  Simplified variant (no cross-matrix): four independent breakdowns are returned in the same payload — per question, per section (area), per position and per region. 
     * @summary Get answer distribution stats for stage 2 (TEST)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] Same semantics as on &#x60;/participants&#x60; (firstName, lastName, email, externalEmployeeId). 
     * @param {Array<string>} [positionCodes] Multi-value (CSV) - OR.
     * @param {Array<string>} [regionCodes] Multi-value (CSV) - OR.
     * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR.
     * @param {number} [termId] 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] 
     * @param {number} [testScoreMax] 
     * @param {number} [testAttemptsMin] 
     * @param {number} [testAttemptsMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStatisticsApiInterface
     */
    getTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig): AxiosPromise<TestAnswerDistributionDto>;

}

/**
 * TestStatisticsApi - object-oriented interface
 * @export
 * @class TestStatisticsApi
 * @extends {BaseAPI}
 */
export class TestStatisticsApi extends BaseAPI implements TestStatisticsApiInterface {
    /**
     * Same data as `getTestAnswerDistribution`, exported as a multi-sheet `.xlsx` file (Filtry / Per pytanie / Per obszar / Per stanowisko / Per region). 
     * @summary Export answer distribution stats as XLSX
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {Array<string>} [positionCodes] 
     * @param {Array<string>} [regionCodes] 
     * @param {Array<ParticipantStageStatusDto>} [testStatus] 
     * @param {number} [termId] 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] 
     * @param {number} [testScoreMax] 
     * @param {number} [testAttemptsMin] 
     * @param {number} [testAttemptsMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStatisticsApi
     */
    public exportTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig) {
        return TestStatisticsApiFp(this.configuration).exportTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated knowledge-test statistics for ALL participants matching the given participants-view filters (ignores pagination). For every participant the BEST attempt (highest `score`) is used.  Simplified variant (no cross-matrix): four independent breakdowns are returned in the same payload — per question, per section (area), per position and per region. 
     * @summary Get answer distribution stats for stage 2 (TEST)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] Same semantics as on &#x60;/participants&#x60; (firstName, lastName, email, externalEmployeeId). 
     * @param {Array<string>} [positionCodes] Multi-value (CSV) - OR.
     * @param {Array<string>} [regionCodes] Multi-value (CSV) - OR.
     * @param {Array<ParticipantStageStatusDto>} [testStatus] Multi-value (CSV) - OR.
     * @param {number} [termId] 
     * @param {boolean} [testPassed] 
     * @param {number} [testScoreMin] 
     * @param {number} [testScoreMax] 
     * @param {number} [testAttemptsMin] 
     * @param {number} [testAttemptsMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestStatisticsApi
     */
    public getTestAnswerDistribution(certificationId: number, stageId: number, search?: string, positionCodes?: Array<string>, regionCodes?: Array<string>, testStatus?: Array<ParticipantStageStatusDto>, termId?: number, testPassed?: boolean, testScoreMin?: number, testScoreMax?: number, testAttemptsMin?: number, testAttemptsMax?: number, options?: RawAxiosRequestConfig) {
        return TestStatisticsApiFp(this.configuration).getTestAnswerDistribution(certificationId, stageId, search, positionCodes, regionCodes, testStatus, termId, testPassed, testScoreMin, testScoreMax, testAttemptsMin, testAttemptsMax, options).then((request) => request(this.axios, this.basePath));
    }
}

